import { render, staticRenderFns } from "./SentReset.vue?vue&type=template&id=f0f94570&"
import script from "./SentReset.vue?vue&type=script&lang=js&"
export * from "./SentReset.vue?vue&type=script&lang=js&"
import style0 from "./SentReset.vue?vue&type=style&index=0&id=f0f94570&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports